<template>
  <a
    class="menu-item"
    :class="{
      'menu-item--current': isCurrent,
      disabled
    }"
    @click="openLink"
    :href="link"
    target="_blank"
  >
    <slot/>
    <div class="menu-item-content">
      {{ name }}
      <img
        class="menu-item__icon"
        src="@/assets/global-icons/arrow-right-white.svg"
        v-if="!disabled"
      />
    </div>
  </a>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'SettingsItem',
  props: {
    id: String,
    name: String,
    link: String,
    disabled: {type: Boolean, default: false},
  },
  computed: {
    ...mapGetters(['getCurrentAreaId', 'viewport/isMobile']),
    isCurrent() {
      return this.$route.path.includes(this.link);
    }
  },
  methods: {
    ...mapActions(['routing/change', 'sidebar/close']),
    openLink(event) {
      if(this.disabled) return
      if(/^(?:[a-z]+:)?\/\//i.test(this.link)) return;

      event.preventDefault();

      if(this.$listeners.click) return this.$listeners.click();

      let path = `${this.getCurrentAreaId}${this.link}`

      if (path) {
        // On mobile, close the sidebar to show the user the content
        if (this['viewport/isMobile']) this['sidebar/close']()

        if (!this.isCurrent) {
          const pathId = this.id;
          this['routing/change']({name:pathId});
        }
      }
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.menu-item {
  display: flex;
  align-items: center;

  color: white;
  text-decoration: none;
  cursor: pointer;
  width: 100%;
  margin-top: 25px;
  font-weight: bold;

  &-content {
    opacity: 0.75;
    display: flex;
    align-items: center;
    flex-grow: 1;
  }
  &:hover:not(.disabled) &-content {
    opacity: 1;
  }

  &__icon {
    height: 14px;
    margin-left: auto;
  }

  &--current {
    opacity: 1;
    cursor: auto;
    text-decoration: underline;
  }
}
</style>
